import React from "react";
import HeaderLogo from "../../../../assets/images/logo.svg";
import HeaderLogoMinified from "../../../../assets/images/logo-sm.svg";
import SidebarItemsGroup from "../SidebarItemsGroup";
import { SidebarItemT } from "../types";
import { NavLink, useHistory } from "react-router-dom";
import SidebarCompanySwitcher from "../SidebarCompanySwitcher";
import { Collapse, Fade } from "@mui/material";
import { useAppDispatch } from "@redux/hooks";
import { setCompany } from "@redux/features/auth/authSlice";

interface DrawerContentProperties {
    items: SidebarItemT[],
    isMinified: boolean
}

export default function DrawerContent({
                                          items,
                                          isMinified
                                      }: DrawerContentProperties) {
    return (
        <div className={`space-y-[32px] px-[20px] group${isMinified ? ` minified` : ``}`}>
            <div className="pt-[56px] text-center">
                <NavLink to={"/dashboard/main"}>
                    {
                        isMinified
                            ? <img src={HeaderLogoMinified} width={44} alt="suppli logo" />
                            : <img src={HeaderLogo} alt="suppli logo" />
                    }
                </NavLink>
            </div>

            {
                <Fade in={!isMinified}>
                    <div>
                        <Collapse in={!isMinified}>
                            <div>
                                <SidebarCompanySwitcher />
                            </div>
                        </Collapse>
                    </div>
                </Fade>
            }

            <SidebarItemsGroup
                items={items}
                recursionHierarchy={[]}
                useIntending={false}
                isMinified={isMinified}
            />
        </div>
    );
}